import { message as BitMessage } from "@bit-design/react";

/**
 * 完全原始的message
 * @param text
 * @param type
 * @param x
 * @param y
 * @param duration
 * @param onClose
 */
function message(
  text: string,
  type: "primary" | "success" | "warning" | "error" | "loading",
  x: "start" | "center" | "end",
  y: "start" | "center" | "end",
  duration: number,
  onClose?: () => void
) {
  return BitMessage[type]({
    content: text,
    duration: 3,
    onClose: onClose,
  });
}

/**
 * 成功信息
 * @param msg
 * @param onClose
 */
message.success = (msg: string, onClose?: () => void) => {
  return BitMessage.success({
    content: msg,
    duration: 3,
    onClose: onClose,
  });
};

/**
 * 警告信息
 * @param msg
 * @param onClose
 */
message.warning = (msg: string, onClose?: () => void) => {
  return BitMessage.warning({
    content: msg,
    duration: 3,
    onClose: onClose,
  });
};

/**
 * 错误信息
 * @param msg
 * @param onClose
 */
message.error = (msg: string, onClose?: () => void) => {
  return BitMessage.error({
    content: msg,
    duration: 3,
    onClose: onClose,
  });
};

/**
 * 主要信息
 * @param msg
 * @param onClose
 */
message.info = (msg: string, onClose?: () => void) => {
  return BitMessage.info({
    content: msg,
    duration: 3,
    onClose: onClose,
  });
};

/**
 * 加载信息
 * @param msg
 * @param onClose
 */
message.loading = (msg: string, onClose?: () => void) => {
  return BitMessage.loading({
    content: msg,
    duration: 3,
    onClose: onClose,
  });
};

export default message;
